import cn from 'bem-cn';

import { List, Stack } from '../../../UI';

import type { ChallengeCriteriasProps, ChallengeCriteriaType } from './ChallengeCriterias.types';
import { ChallengeCriteria } from './ChallengeCriteria';
import './ChallengeCriterias.scss';

const b = cn('challenge-criterias');

const renderCriteria = (item: ChallengeCriteriaType) => <ChallengeCriteria {...item} />;
const extractTagKey = (_: ChallengeCriteriaType, index: number) => `criteria-${index}`;

export const ChallengeCriterias = (props: ChallengeCriteriasProps) => {
    const { criterias } = props;

    if (!criterias?.length) {
        return null;
    }

    return (
        <Stack className={b()}>
            <h2 className={b('title')}>Критерии оценки</h2>
            <List
                direction="row"
                className={b('list')}
                items={criterias}
                renderItem={renderCriteria}
                keyExtractor={extractTagKey}
            />
        </Stack>
    );
};
